// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__Bftu4","title":"AfterFrontImage_title__1MF80"};